import { useEffect } from "react";
import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
}

export function Eyebrow({ children }) {
  return (
    <span
      data-testid="section-eyebrow"
      className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-teal-700"
    >
      <span className="h-px w-8 bg-teal-600/60" />
      {children}
    </span>
  );
}

export function PageHero({ eyebrow, title, lead, testId }) {
  return (
    <section data-testid={testId} className="relative overflow-hidden bg-white">
      <div
        className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-teal-100/60 blur-3xl"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-6xl px-5 pb-14 pt-28 sm:px-8 sm:pt-36">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-5 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {lead && (
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
              {lead}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
